import servicesUtils from "../../../utils/servicesUtils";
import { SyncStatusResponse } from "../types";

const getSyncStatus = (apiParams = {}): Promise<SyncStatusResponse> => {
  return new Promise((resolve, reject) => {
    servicesUtils
      .getService<SyncStatusResponse>("/qsync/status/", apiParams)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getSyncStatus;
